/**
 * Утилиты для валидации и преобразования текста в SEO формах
 */

/**
 * Словарь для транслитерации русских символов
 */
const translitMap: Record<string, string> = {
  'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo',
  'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm',
  'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
  'ф': 'f', 'х': 'h', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'sch',
  'ъ': '', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu', 'я': 'ya',
  'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'Yo',
  'Ж': 'Zh', 'З': 'Z', 'И': 'I', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M',
  'Н': 'N', 'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
  'Ф': 'F', 'Х': 'H', 'Ц': 'Ts', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Sch',
  'Ъ': '', 'Ы': 'Y', 'Ь': '', 'Э': 'E', 'Ю': 'Yu', 'Я': 'Ya'
}

/**
 * Транслитерация русского текста в английский
 */
export const transliterate = (text: string): string => {
  return text
    .split('')
    .map(char => translitMap[char] || char)
    .join('')
}

/**
 * Проверяет, содержит ли текст русские символы
 */
export const hasRussianCharacters = (text: string): boolean => {
  const russianRegex = /[а-яё]/i
  return russianRegex.test(text)
}

/**
 * Преобразует текст в URL-friendly формат
 * Сначала транслитерирует, затем заменяет пробелы и знаки на подчеркивания
 */
export const convertToUrlFriendly = (text: string): string => {
  return transliterate(text)
    .trim()
    .toLowerCase()
    // Заменяем множественные пробелы на один
    .replace(/\s+/g, ' ')
    // Заменяем пробелы, точки, запятые, скобки и другие знаки на подчеркивания
    .replace(/[\s.,()[\]{}!@#$%^&*+=|\\:";'<>?/`~]/g, '_')
    // Удаляем множественные подчеркивания
    .replace(/_+/g, '_')
    // Удаляем подчеркивания в начале и конце
    .replace(/^_+|_+$/g, '')
}

/**
 * Валидатор для поля "Текст селектора" - теперь разрешаем любые символы
 * Валидация убрана, поскольку русский текст будет автоматически транслитерироваться для URL
 */
export const validateSelectorText = (_: any, value: string) => {
  // Убираем валидацию на английский язык - теперь разрешаем русский текст
  return Promise.resolve()
}

/**
 * Валидатор для URL - запрет русских символов
 */
export const validateUrl = (_: any, value: string) => {
  if (!value || !value.trim()) {
    return Promise.resolve()
  }

  if (hasRussianCharacters(value)) {
    return Promise.reject(new Error('URL не может содержать русские символы'))
  }

  return Promise.resolve()
}